import React, { useState, useContext } from 'react';
import { UserContext } from '../context/UserContext';
import Input from '../AddForm/Input';

const initialState = {
  email: '',
  password: '',
};

function SignInForm() {
  const { signIn } = useContext(UserContext);
  const [signFormValue, setSignFormValue] = useState(initialState);

  function handlerFormValue(event) {
    const key = event.target.name;
    const value = event.target.value;
    setSignFormValue({ ...signFormValue, [key]: value });
  }

  function handlerSubmit(event) {
    event.preventDefault();
    const email = signFormValue.email;
    const password = signFormValue.password;
    signIn(email, password);
    setSignFormValue(initialState);
  }

  return (
    <>
      <h1>Sign in</h1>
      <form onSubmit={(event) => handlerSubmit(event)}>
        <Input
          type="email"
          name="email"
          value={signFormValue.email}
          onChange={(event) => handlerFormValue(event)}
          label="Email:"
        />
        <Input
          type="password"
          name="password"
          value={signFormValue.password}
          onChange={(event) => handlerFormValue(event)}
          label="Password:"
        />
        <Input
          type="submit"
          name="submit"
          value="Sign In!"
          className="sumbitInput"
        />
      </form>
    </>
  );
}

export default SignInForm;
